import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import Drawer from '@mui/material/Drawer';
import { useLocation, Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { Icons } from '@/components/icons';
import { LibraryBooks, SwapHoriz } from '@mui/icons-material';

export function ReaderSidebar() {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const menuItems = [
    {
      href: '/library',
      label: t('reader.sidebar.current_reads'),
      icon: LibraryBooks,
    },
    {
      href: '/',
      label: t('reader.sidebar.writer_mode'),
      icon: SwapHoriz,
    },
  ];

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: 260,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: 260,
          boxSizing: 'border-box',
          bgcolor: 'background.paper',
          borderRight: '1px solid',
          borderColor: 'divider',
        },
      }}
    >
      {/* Header with ePlotera Logo and Brand */}
      <Box sx={{ p: 0, display: 'flex', alignItems: 'center', minHeight: 64, px: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexGrow: 1, overflow: 'hidden' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: 48, height: 48, flexShrink: 0 }}>
            <Icons.logo width={36} height={36} />
          </Box>
          <Typography variant="h6" sx={{ fontWeight: 800, letterSpacing: '-0.02em', color: 'text.primary', whiteSpace: 'nowrap' }}>
            {t('marketing.title')}
          </Typography>
        </Box>
      </Box>

      <Divider sx={{ opacity: 0.5 }} />

      {/* Nav List */}
      <List sx={{ px: 1, py: 2 }}>
        {menuItems.map((item) => {
          const isActive = item.href === '/library' ? pathname.startsWith('/library') || pathname.startsWith('/read') : pathname === '/';
          const Icon = item.icon;

          return (
            <ListItem key={item.href} disablePadding sx={{ mb: 0.5 }}>
              <ListItemButton
                component={Link}
                to={item.href}
                selected={isActive}
                sx={{
                  borderRadius: '8px',
                  py: 1,
                  '&.Mui-selected': {
                    bgcolor: 'action.selected',
                    color: 'primary.main',
                    '& .MuiListItemIcon-root': {
                      color: 'primary.main',
                    },
                    '&:hover': {
                      bgcolor: 'action.selected',
                    },
                  },
                  '&:hover': {
                    bgcolor: 'action.hover',
                    '& .MuiListItemIcon-root': {
                      color: 'primary.main',
                    },
                  },
                  transition: 'all 0.2s ease',
                }}
              >
                <ListItemIcon sx={{ minWidth: 40, color: isActive ? 'primary.main' : 'text.secondary', justifyContent: 'center' }}>
                  <Icon sx={{ fontSize: 20 }} />
                </ListItemIcon>
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{
                    fontSize: '0.9rem',
                    fontWeight: isActive ? 600 : 500,
                    color: isActive ? 'text.primary' : 'text.secondary',
                  }}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Drawer>
  );
}
